import { render, staticRenderFns } from "./InProcessingPage.vue?vue&type=template&id=f9479e76&"
import script from "./InProcessingPage.vue?vue&type=script&lang=ts&"
export * from "./InProcessingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9479e76')) {
      api.createRecord('f9479e76', component.options)
    } else {
      api.reload('f9479e76', component.options)
    }
    module.hot.accept("./InProcessingPage.vue?vue&type=template&id=f9479e76&", function () {
      api.rerender('f9479e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/InProcessingPage.vue"
export default component.exports